import React, { Fragment, Component } from "react";
import { Image, Button, Row, Col } from "react-bootstrap";
import moment from "moment";
import CallingButtonPopup from "../../../../reusableComponents/allPopupReusable/CallingButtonPopup";
import SendSmsNew from "../../../../reusableComponents/allPopupReusable/SendSmsNew";
import NotificationsNew from "../../../../reusableComponents/allPopupReusable/NotificationsNew";
import Alert from "react-s-alert";
import NewCountDown from "../../../../reusableComponents/allPopupReusable/tableNumberPopup/NewCountDown";
import { CAR_COLORS, NEW_PAYMENT_TYPE } from "../../../../../enums/OrderEnums";
import { ITEMTYPEVEG } from "../../../../../enums/OrderEnums";
import { NOTAVAILABLEIMAGE } from "../../../../../enums/GlobalEnums";
import CallingIconButtonActionFile from "../../../../reusableComponents/allPopupReusable/tableNumberPopup/CallingIconButtonAction/CallingIconButtonActionFile";
// import hi from "../../../../../"

class OrderDescModelBody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      spice: 4,
      sugar: 4,
      salt: 5,
      fat: 5,
      meat: 5,
      egg: 5,
      diff: 0,
    };
  }
  // const [cookLevels, setCookLevels] = useState({
  //   spice: 4,
  //   sugar: 4,
  //   salt: 5,
  //   fat: 5,
  //   meat: 5,
  //   egg: 5,
  // });

  updatedTime = moment(
    this.props?.allData?.max_time_date || this.props?.allData?.OrderAcceptTime
  ).add(parseInt(this.props?.allData?.max_time), "minutes");

  diff = this.updatedTime.diff(moment());

  getAddOns = (data) => {
    let addOnsNames = [];
    for (let i = 0; i < data.length; i++) {
      for (let j = 0; j < data[i].options.length; j++) {
        addOnsNames.push(data[i].options[j].name);
      }
    }
    return addOnsNames.toString();
  };

  prepareLevels = (data) => {
    let levelNames = [];

    if (data.spice_level) {
      let spice = "Spice : " + data.spice_level.level + "/" + this.state.spice;
      levelNames.push(spice);
    }

    if (data.salt_level) {
      let salt = "Salt : " + data.salt_level.level + "/" + this.state.salt;
      levelNames.push(salt);
    }

    if (data.sugar_level) {
      let sugar = "Sugar : " + data.sugar_level.level + "/" + this.state.sugar;
      levelNames.push(sugar);
    }

    if (data.fat_level) {
      let fat =
        "fat/oil/fried : " + data.fat_level.level + "/" + this.state.fat;
      levelNames.push(fat);
    }

    if (data.meat_cook_level) {
      let meat = "Meat : " + data.meat_cook_level.level + "/" + this.state.meat;
      levelNames.push(meat);
    }

    if (data.egg_cook_level) {
      let egg = "Egg : " + data.egg_cook_level.level + "/" + this.state.egg;
      levelNames.push(egg);
    }
    return levelNames.toString();
  };

  onClickResetReject = (orderStatus, id, orderType) => {
    let prepData = {};
    if (orderStatus === 0) {
      prepData = { order_status: 8, id: id };
    } else if (orderStatus === 6 && orderType === 3) {
      prepData = { order_status: orderStatus - 2, id: id };
    } else {
      prepData = { order_status: orderStatus - 1, id: id };
    }
    this.props.onUpdateOrderStatus(prepData);
  };

  onClickChangeStatusAlert = () => {
    Alert.error(
      `<h4>You can't perform this action because payment is not done</h4>`,
      {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      }
    );
  };

  getAddOns = (data) => {
    let addOnsNames = [];
    if (data && data[0] && data[0].options) {
      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < data[i].options.length; j++) {
          addOnsNames.push(data[i].options[j].name);
        }
      }
    } else {
      for (let i = 0; i < data.length; i++) {
        addOnsNames.push(data[i].name);
      }
    }
    return addOnsNames.toString();
  };

  onClickChangeStatus = (orderStatus, id, orderType) => {
    var formData = {};
    if (orderType === 3 && orderStatus === 4) {
      // check for dine in order
      formData = { order_status: orderStatus + 2, id: id };
    } else {
      formData = { order_status: orderStatus + 1, id: id };
    }
    if (orderStatus + 1 === 1) {
      formData.OrderAcceptTime = new Date().getTime();
    }
    if (orderType === 3 && orderStatus === 6) {
      if (orderStatus + 1 === 7) {
        formData.OrderCompleteTime = new Date().getTime();
      }
    } else {
      if (orderStatus + 1 === 7) {
        formData.OrderCompleteTime = new Date().getTime();
      }
    }

    this.props.onUpdateOrderStatus(formData);
  };

  // calcTotalItems = () => {
  //   let data = JSON.parse(JSON.stringify(this.props?.allData));
  //   let qty = 0;
  //
  //   for (let i = 0; i < data.order_items.length; i++) {
  //     qty = qty + data.order_items[i].quantity;
  //   }
  //   return qty;
  // };

  

  render() {
    console.log('this.props?', this.props?.allData)
    const updatedTime = moment(
      this.props?.allData?.max_time_date || this.props?.allData?.OrderAcceptTime
    ).add(parseInt(this.props?.allData?.max_time), "minutes");
    let diff = updatedTime.diff(moment());
    return (
      <React.Fragment>
        <div className="superadmin-orderscomponent-main">
          <div
            className="model-head-view-order-detailed "
            style={{
              border: "1px solid #E0E0E0",
              padding: "1%",
              borderRadius: "5px 0px 0px 5px",
            }}
          >
            <div
              style={{
                borderRadius: "5px",
                borderLeft: "5px solid #37ac1e",
                paddingLeft: "1%",
              }}
            >
              <div className="row">
                <div className="col-2 col-sm-2 col-md-1 mb-3">
                  <h5 className="f12-700 mb-2">Order Type</h5>
                  <img
                    src={
                      this.props?.allData &&
                      this.props?.allData?.order_type === 0
                        ? require("../../../../../assets/images/superadmin/ordericon/takeaway.svg")
                        : this.props?.allData &&
                          this.props?.allData?.order_type === 1
                        ? require("../../../../../assets/images/superadmin/ordericon/curb side.svg")
                        : this.props?.allData &&
                          this.props?.allData?.order_type === 3
                        ? require("../../../../../assets/images/superadmin/ordericon/dine in.svg")
                        : this.props?.allData &&
                          this.props?.allData?.order_type === 2
                        ? require("../../../../../assets/images/superadmin/ordericon/skip the line.svg")
                        : this.props?.allData &&
                          this.props?.allData?.order_type === 7
                        ? require("../../../../../assets/images/superadmin/ordericon/delivery.svg")
                        : ""
                    }
                    alt={
                      this.props?.allData &&
                      this.props?.allData?.order_type === 0
                        ? "takeaway"
                        : this.props?.allData &&
                          this.props?.allData?.order_type === 1
                        ? "curb side"
                        : this.props?.allData &&
                          this.props?.allData?.order_type === 3
                        ? "dine in"
                        : this.props?.allData &&
                          this.props?.allData?.order_type === 7
                        ? "Home Delivery"
                        : ""
                    }
                    title={
                      this.props?.allData &&
                      this.props?.allData?.order_type === 0
                        ? "takeaway"
                        : this.props?.allData &&
                          this.props?.allData?.order_type === 1
                        ? "curb side"
                        : this.props?.allData &&
                          this.props?.allData?.order_type === 3
                        ? "dine in"
                        : this.props?.allData &&
                          this.props?.allData?.order_type === 7
                        ? "Home Delivery"
                        : ""
                    }
                    width="25px"
                  />
                </div>
                <div className="col mb-3">
                  <h5 className="f12-700 mb-2">Name & Request No.</h5>
                  <p className="f12-700 mt-md-4">
                    {this.props?.allData &&
                      this.props?.allData?.user_details &&
                      this.props?.allData?.user_details.first_name}{" "}
                    {this.props?.allData &&
                      this.props?.allData?.user_details &&
                      this.props?.allData?.user_details.last_name}
                  </p>
                  <p className="f11-500 mt-2">
                    #{this.props?.allData?.order_id}
                  </p>
                  <p className="f11-500">
                    {" "}
                    {this.props?.allData?.user_details.country_code}{" "}
                    {(this.props?.allData?.restaurant_id?.userDetails && moment(this.props?.allData?.restaurant_id?.userDetailsDate).isBefore(this.props?.allData?.createdAt)) ? this.props?.allData?.user_details.mobile_number : this.props?.allData?.user_details.mobile_number.replace(
                      /\d(?=\d{3})/g,
                      "*"
                    )}
                  </p>
                </div>
                <div className="col-2 col-sm-2 col-md-1 mb-3">
                  <h5 className="f12-700 mb-1">No. Items</h5>
                  <p className="f12-700">
                    {this.props?.allData &&
                      this.props?.allData &&
                      this.props?.allData?.order_items.length}
                  </p>
                </div>
                <div className="col mb-3 text-center">
                  <h5 className="f12-700 mb-2">Amount / Payment</h5>
                  <p className="f12-700 mt-3 pt-1">
                    ₹{" "}
                    {this.props?.allData &&
                      this.props?.allData &&
                      this.props?.allData?.total_amount &&
                      this.props?.allData?.total_amount.toFixed(2)}{" "}
                  </p>
                  <p
                    className={`badge f10-400 text-white mt-2 px-3 py-1 ${
                      this.props &&
                      this.props?.allData &&
                      this.props?.allData?.payment_status === 1
                        ? "badge-success"
                        : "badge-danger"
                    }`}
                    style={{ borderRadius: 50 }}
                  >
                    {" "}
                    {this.props &&
                    this.props?.allData &&
                    this.props?.allData?.payment_status === 1
                      ? "PAID"
                      : this.props &&
                        this.props?.allData &&
                        this.props?.allData?.payment_status === 0
                      ? "UNPAID"
                      : this.props?.allData?.payment_status === 3
                      ? "FAILURE"
                      : "N/A"}
                  </p>
                  <p className="f12-700 mt-1">
                    {this.props?.allData?.splitPayment ? (
                      <>Split Payment</>
                    ) : (
                      NEW_PAYMENT_TYPE[this.props?.allData?.payment_method]
                    )}
                  </p>
                </div>
                <div className="col mb-3">
                  <h5 className="f12-700 mb-2">Total Pax</h5>
                  <div className="f11-500 mt-3">
                    {this.props?.allData &&
                    this.props?.allData?.order_type === 3
                      ? this?.props?.allData?.totalDinePax !== null &&
                        this?.props?.allData?.totalDinePax !== undefined
                        ? this?.props?.allData?.totalDinePax
                        : "_"
                      : "_"}
                  </div>
                </div>
                <div className="col mb-3">
                  <h5 className="f12-700 mb-2">Order Reference</h5>
                  <p className="f11-500 mt-3">
                    {this.props?.allData?.order_type === 1 ? (
                      <Fragment>
                        {this.props?.allData &&
                          this.props?.allData?.curb_side_details &&
                          this.props?.allData?.curb_side_details.number}{" "}
                        <br />
                        {this.props?.allData &&
                          this.props?.allData?.curb_side_details &&
                          this.props?.allData?.curb_side_details.model}{" "}
                        {this.props?.allData &&
                          this.props?.allData?.curb_side_details &&
                          this.props?.allData?.curb_side_details.make}
                        |{" "}
                        {CAR_COLORS &&
                          CAR_COLORS.map((data, index) => {
                            return data.value ===
                              this.props?.allData?.curb_side_details?.color
                              ? data?.name
                              : "";
                          })}
                      </Fragment>
                    ) : (this.props.allData &&
                        this.props.allData.order_type === 3) ||
                      (this.props.allData &&
                        this.props.allData.order_type === 2) ? (
                      <Fragment>
                        {this.props.allData.dine_in_details?.table_number || "Self Pick-up"}
                      </Fragment>
                    ) : this.props.allData?.order_type === 7 &&
                      this.props.allData?.deliveryAddress ? (
                      <React.Fragment>
                        <a
                          target="_blank"
                          style={{
                            textDecoration: "none",
                            color: "inherit",
                          }}
                          href={`https://www.google.com/maps/place/${this.props.allData?.deliveryAddress?.location?.latitude},${this.props.allData?.deliveryAddress?.location?.longitude}`}
                        >
                          <p className="f10-500 mb-2">
                            {this.props.allData?.deliveryAddress?.address1}
                          </p>
                        </a>
                        <p className="f10-400 mb-2">
                          {this.props.allData?.deliveryAddress?.area || ""},{" "}
                          {this.props.allData?.deliveryAddress?.city || ""}
                        </p>
                      </React.Fragment>
                    ) : (
                      "N/A"
                    )}
                  </p>
                </div>
                <div className="col mb-3">
                  <h5 className="f12-700 mb-2">Date / Time / Timer</h5>
                  <div className="date-time-timer-body mt-3">
                    <div className="time-and-edit-button">
                      <div className="timer-section mr-2">
                        <h4
                          className="timer-count"
                          style={{ color: "#EE3A23" }}
                        >
                          {/* {(this.props?.allData &&
                              this.props?.allData?.order_status === 7) ||
                            (this.props?.allData &&
                              this.props?.allData?.order_status === 8) ? (
                              <></>
                            ) : this.props?.allData &&
                              this.props?.allData?.order_status === 0 ? (
                              "00:00:00"
                            ) : ( */}
                          <NewCountDown waitNew={diff} />
                          {/* )} */}

                          {/* {(this.props?.allData &&
                              this.props?.allData?.order_status === 7) ||
                            (this.props?.allData &&
                              this.props?.allData?.order_status === 8) ? (
                              <> </>
                            ) : this.props?.allData && this.props?.allData?.order_status === 0 ? "" : "" : (
                              <NewCountDown waitNew={diff} />
                            )} */}
                        </h4>
                      </div>
                      {(this.props?.allData &&
                        this.props?.allData?.order_status === 0) ||
                      (this.props?.allData &&
                        this.props?.allData?.order_status === 7) ||
                      (this.props?.allData &&
                        this.props?.allData?.order_status === 8) ? (
                        <> </>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* <table className="model-view-order-detailed-table">
                <thead>
                  <th className="f12-500" style={{ width: "8%" }}>
                    Order Type
                  </th>
                  <th className="f12-500" style={{ width: "18%" }}>
                    Name & Request No.
                  </th>
                  <th className="f12-500" style={{ width: "10%" }}>
                    No. Items
                  </th>
                  <th className="f12-500" style={{ width: "10%" }}>
                    Amount / Payment
                  </th>
                  <th className="f12-500 text-center" style={{ width: "18%" }}>
                    Total Pax
                  </th>
                  <th className="f12-500" style={{ width: "18%" }}>
                    Order Reference
                  </th>
                  <th className="f12-500" style={{ width: "18%" }}>
                    Date / Time / Timer
                  </th>
                </thead>
                <tbody style={{ marginTop: "1%" }}>
                  <tr>
                    <td>
                      <img
                        src={
                          this.props?.allData &&
                          this.props?.allData?.order_type === 0
                            ? require("../../../../../assets/images/superadmin/ordericon/takeaway.svg")
                            : this.props?.allData &&
                              this.props?.allData?.order_type === 1
                            ? require("../../../../../assets/images/superadmin/ordericon/curb side.svg")
                            : this.props?.allData &&
                              this.props?.allData?.order_type === 3
                            ? require("../../../../../assets/images/superadmin/ordericon/dine in.svg")
                            : this.props?.allData &&
                              this.props?.allData?.order_type === 2
                            ? require("../../../../../assets/images/superadmin/ordericon/skip the line.svg")
                            : this.props?.allData &&
                              this.props?.allData?.order_type === 7
                            ? require("../../../../../assets/images/superadmin/ordericon/delivery.svg")
                            : ""
                        }
                        alt={
                          this.props?.allData &&
                          this.props?.allData?.order_type === 0
                            ? "takeaway"
                            : this.props?.allData &&
                              this.props?.allData?.order_type === 1
                            ? "curb side"
                            : this.props?.allData &&
                              this.props?.allData?.order_type === 3
                            ? "dine in"
                            : this.props?.allData &&
                              this.props?.allData?.order_type === 7
                            ? "Home Delivery"
                            : ""
                        }
                        title={
                          this.props?.allData &&
                          this.props?.allData?.order_type === 0
                            ? "takeaway"
                            : this.props?.allData &&
                              this.props?.allData?.order_type === 1
                            ? "curb side"
                            : this.props?.allData &&
                              this.props?.allData?.order_type === 3
                            ? "dine in"
                            : this.props?.allData &&
                              this.props?.allData?.order_type === 7
                            ? "Home Delivery"
                            : ""
                        }
                        width="35px"
                      />
                    </td>
                    <td>
                      {this.props?.allData &&
                        this.props?.allData?.user_details &&
                        this.props?.allData?.user_details.first_name}{" "}
                      {this.props?.allData &&
                        this.props?.allData?.user_details &&
                        this.props?.allData?.user_details.last_name}
                      <br />
                      <span className="f11-500">
                        #{this.props?.allData?.order_id}
                      </span>
                      <br />
                      <span className="f11-500">
                        {" "}
                        {this.props?.allData &&
                          this.props?.allData?.user_details &&
                          this.props?.allData?.user_details.country_code}{" "}
                        {this.props?.allData &&
                          this.props?.allData?.user_details &&
                          this.props?.allData?.user_details.mobile_number}
                      </span>
                    </td>
                    <td>
                      {" "}
                      {this.props?.allData &&
                        this.props?.allData &&
                        this.props?.allData?.order_items.length}
                    </td>
                    <td>
                      {this.props?.allData &&
                        this.props?.allData &&
                        this.props?.allData?.total_amount &&
                        this.props?.allData?.total_amount.toFixed(2)}{" "}
                      <br />
                      <span
                        className={`badge ${
                          this.props &&
                          this.props?.allData &&
                          this.props?.allData?.payment_status === 1
                            ? "badge-success"
                            : "badge-danger"
                        }`}
                      >
                        {" "}
                        {this.props &&
                        this.props?.allData &&
                        this.props?.allData?.payment_status === 1
                          ? "PAID"
                          : this.props &&
                            this.props?.allData &&
                            this.props?.allData?.payment_status === 0
                          ? "UNPAID"
                          : this.props?.allData?.payment_status === 3
                          ? "FAILURE"
                          : "N/A"}
                      </span>
                      <br />
                      {/* <div className="f12-500">
                          {this.props?.allData?.transactionDetails.map((data,index) => {
                            return (
                             <>
                              {NEW_PAYMENT_TYPE[data?.paymentType]}
                              {" "}
                             </>
                            )
                          }) }
                        </div> *
                      <div className="f12-500">
                        {this.props?.allData?.splitPayment ? (
                          <>Split Payment</>
                        ) : (
                          NEW_PAYMENT_TYPE[this.props?.allData?.payment_method]
                        )}
                      </div>
                      {/* {this.props?.allData &&
                      this.props?.allData?.payment_method === 0
                        ? "COD"
                        : this.props?.allData?.payment_method === 1
                        ? "UPI"
                        : this.props?.allData?.payment_method === 2
                        ? "Paytm"
                        : this.props?.allData?.payment_method === 3
                        ? "Debit Card"
                        : this.props?.allData?.payment_method === 4
                        ? "Credit Card"
                        : this.props?.allData?.payment_method === 5
                        ? "NetBanking"
                        : this.props?.allData?.payment_method === 6
                        ? "Pay Later"
                        : this.props?.allData?.payment_method === 7
                        ? "Wallet"
                        : this.props?.allData?.payment_method === 8
                        ? "External Wallet"
                        : this.props?.allData?.payment_method === 9
                        ? "Cash"
                        : null} *
                    </td>
                    <td className="text-center">
                      <div className="f12-500">
                        {this.props?.allData &&
                        this.props?.allData?.order_type === 3
                          ? this?.props?.allData?.totalDinePax !== null &&
                            this?.props?.allData?.totalDinePax !== undefined
                            ? this?.props?.allData?.totalDinePax
                            : "_"
                          : "_"}
                      </div>
                    </td>
                    <td>
                      {this.props?.allData?.order_type === 1 ? (
                        <Fragment>
                          {this.props?.allData &&
                            this.props?.allData?.curb_side_details &&
                            this.props?.allData?.curb_side_details.number}{" "}
                          <br />
                          {this.props?.allData &&
                            this.props?.allData?.curb_side_details &&
                            this.props?.allData?.curb_side_details.model}{" "}
                          {this.props?.allData &&
                            this.props?.allData?.curb_side_details &&
                            this.props?.allData?.curb_side_details.make}
                          |{" "}
                          {CAR_COLORS &&
                            CAR_COLORS.map((data, index) => {
                              return data.value ===
                                this.props?.allData?.curb_side_details?.color
                                ? data?.name
                                : "";
                            })}
                        </Fragment>
                      ) : (this.props.allData &&
                          this.props.allData.order_type === 3) ||
                        (this.props.allData &&
                          this.props.allData.order_type === 2) ? (
                        <Fragment>
                          {this.props.allData.dine_in_details?.table_number}
                        </Fragment>
                      ) : this.props.allData?.order_type === 7 &&
                        this.props.allData?.deliveryAddress ? (
                        <React.Fragment>
                          <a
                            target="_blank"
                            style={{
                              textDecoration: "none",
                              color: "inherit",
                            }}
                            href={`https://www.google.com/maps/place/${this.props.allData?.deliveryAddress?.location?.latitude},${this.props.allData?.deliveryAddress?.location?.longitude}`}
                          >
                            <p className="f10-500 mb-2">
                              {this.props.allData?.deliveryAddress?.address1}
                            </p>
                          </a>
                          <p className="f10-400 mb-2">
                            {this.props.allData?.deliveryAddress?.area || ""},{" "}
                            {this.props.allData?.deliveryAddress?.city || ""}
                          </p>
                        </React.Fragment>
                      ) : (
                        "N/A"
                      )}
                    </td>
                    <td>
                      <div className="date-time-timer-body">
                        <div className="time-and-edit-button">
                          <div className="timer-section mr-2">
                            <h4
                              className="timer-count"
                              style={{ color: "#EE3A23" }}
                            >
                              {/* {(this.props?.allData &&
                              this.props?.allData?.order_status === 7) ||
                            (this.props?.allData &&
                              this.props?.allData?.order_status === 8) ? (
                              <></>
                            ) : this.props?.allData &&
                              this.props?.allData?.order_status === 0 ? (
                              "00:00:00"
                            ) : ( *
                              <NewCountDown waitNew={diff} />
                              {/* )} */}

              {/* {(this.props?.allData &&
                              this.props?.allData?.order_status === 7) ||
                            (this.props?.allData &&
                              this.props?.allData?.order_status === 8) ? (
                              <> </>
                            ) : this.props?.allData && this.props?.allData?.order_status === 0 ? "" : "" : (
                              <NewCountDown waitNew={diff} />
                            )} *
                            </h4>
                          </div>
                          {(this.props?.allData &&
                            this.props?.allData?.order_status === 0) ||
                          (this.props?.allData &&
                            this.props?.allData?.order_status === 7) ||
                          (this.props?.allData &&
                            this.props?.allData?.order_status === 8) ? (
                            <> </>
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table> */}
            </div>
            <hr />
            <br />
            <Row>
              <Col className="col-6 col-sm-6 col-md-4">
                <h5 className="f12-500">Order Placed Date & Time</h5>
                <br />
                <p>
                  {moment(
                    this.props?.allData && this.props?.allData?.createdAt
                  ).format("Do MMMM YYYY")}
                  |
                  {moment(
                    this.props?.allData && this.props?.allData?.createdAt
                  ).format("hh : mm A")}
                </p>
              </Col>

              <Col
                className="col-6 col-sm-6 col-md-4 text-center"
                style={{ cursor: "no-drop" }}
              >
                {!this?.props?.admin && (
                  <>
                    <h5 className="f12-500">User Location</h5>
                    <br />
                    <center>
                      <img
                        src={require("../../../../../assets/images/superadmin/ordericon/location_red.svg")}
                        width="25px"
                      />
                    </center>
                  </>
                )}
              </Col>
              <Col className="col-12 col-sm-12 col-md-4 mt-4 mt-md-0">
                <div
                  className="container-fluid main-orders-table-action"
                  align="center"
                >
                  <p style={{ fontSize: ".75rem" }}>Total wait time</p>
                  <div className="row justify-content-center">
                    <div
                      className="col-6"
                      style={
                        {
                          // background: "#F0F0F0 0% 0% no-repeat padding-box",
                          // borderRadius: "6px",
                        }
                      }
                    >
                      <button
                        className="btn btn-secondary w-100 d-flex justify-content-center py-2"
                        style={{
                          fontSize: ".75rem",
                          background: "#F0F0F0 0% 0% no-repeat padding-box",
                          borderRadius: "6px",
                          color: "#000000",
                        }}
                      >
                        <img
                          src={require("../../../../../assets/images/superadmin/ordericon/hourglass.svg")}
                          width="15px"
                        />
                        {/* {this.props?.allData &&
                          this.props?.allData?.order_status === 7 ? (
                            <p className="font_16_m">
                              {seated_time_difference(minutesSeated)}
                            </p>
                          ) : (
                            <p className="font_16_m">00 HH : 00 min</p>
                          )} */}
                        <p className="font_16_m">
                          {this.props?.seated_time_difference}
                        </p>
                      </button>
                    </div>
                  </div>
                  {/* <div>
                    Status:{" "}
                    {this.props?.allData && this.props?.allData?.order_status === 0
                      ? "Pending"
                      : this.props?.allData?.order_status === 1
                        ? "Confirmed"
                        : this.props?.allData?.order_status === 2
                          ? "Preparing"
                          : this.props?.allData?.order_status === 3
                            ? "Packing"
                            : this.props?.allData?.order_status === 4
                              ? "Ready To Pick"
                              : this.props?.allData?.order_status === 5
                                ? "On The Way"
                                : this.props?.allData?.order_status === 6
                                  ? "Delivered"
                                  : this.props?.allData?.order_status === 7
                                    ? "Complete"
                                    : this.props?.allData?.order_status === 8
                                      ? "Cancelled"
                                      : null}
                  </div> */}
                </div>
              </Col>
            </Row>
            <hr />
            <br />
            <Row>
              <Col
                className="col-12 col-sm-12 col-md-3 mb-3 mb-md-0"
                style={{ borderRight: "1px solid #E0E0E0" }}
              >
                <div className="more-actions-orders-desc d-flex justify-content-center mb-2">
                  {/* <Button
                    variant="link"
                    className="enIconBtn mr-3 action_icon_padding"
                    // onClick={props.ratingReviewAction}
                  >
                    <Image
                      src={require("../../../../../assets/images/superadmin/ordericon/call.svg")}
                      alt="Call"
                      title="Call"
                      fluid
                    />
                  </Button> */}

                  {/* <CallingButtonPopup
                    sendData={this.props?.allData}
                    displayButton={"OrderMain"}
                  /> */}
                  <CallingIconButtonActionFile
                    orderDetails={this.props?.allData?.user_details}
                    actionType="orderFirstLastName"
                  />

                  {/* <Button
                    variant="link"
                    className="enIconBtn mr-3 action_icon_padding"
                    // onClick={props.ratingReviewAction}
                  >
                    <Image
                      src={require("../../../../../assets/images/superadmin/ordericon/Edit.svg")}
                      alt="Edit"
                      title="Edit"
                      fluid
                    />
                  </Button>{" "} */}
                  <SendSmsNew
                    mobile_number={
                      this.props?.allData &&
                      this.props?.allData?.user_details &&
                      this.props?.allData?.user_details.mobile_number
                    }
                    first_name={
                      this.props?.allData &&
                      this.props?.allData.user_details &&
                      this.props?.allData.user_details.first_name &&
                      this.props?.allData.user_details.last_name
                        ? this.props?.allData.user_details.first_name +
                          " " +
                          this.props?.allData.user_details.last_name
                        : ""
                    }
                    type="order"
                    order_id={this.props?.allData?._id}
                  />
                  {/* <Button
                    variant="link"
                    className="enIconBtn mr-3 action_icon_padding"
                    // onClick={props.ratingReviewAction}
                  >
                    <Image
                      src={require("../../../../../assets/images/superadmin/ordericon/Notifications.svg")}
                      alt="Notify"
                      title="Notify"
                      fluid
                    />
                  </Button> */}
                  <NotificationsNew order_id={this.props?.allData?._id} />
                </div>
              </Col>
              <Col className="col-5 col-sm-5 col-md-4">
                <h5 className="f12-500">Order Notes</h5>
                <br />
                <p>{this.props?.allData && this.props?.allData?.notes}</p>
              </Col>
              <Col className="col-4 col-sm-4 col-md-2">
                <h5 className="f12-500">ETR</h5>
                <br />
                <p>
                  {this.props?.allData?.reaching_time
                    ? `${this.props?.allData?.reaching_time}min`
                    : "N/A"}
                </p>
              </Col>
              <Col className="col-3 col-sm-3 col-md-3"></Col>
            </Row>
            <hr />
            <br />
            <div className="table-responsive">
              <table className="table desc-order-info">
                <thead>
                  <tr
                    style={{
                      backgroundColor: "transparent",
                      borderTop: "hidden",
                    }}
                  >
                    {/* <th style={{ width: "3%" }}></th> */}
                    <th
                      className="f12-500"
                      style={{ width: "15%" }}
                      colSpan={2}
                    >
                      Order Items
                    </th>
                    <th className="f12-500" style={{ width: "3%" }}>
                      Qty
                    </th>
                    <th className="f12-500" style={{ width: "10%" }}>
                      Customization
                    </th>
                    <th className="f12-500" style={{ width: "20%" }}>
                      Personalization/ Item Notes
                    </th>
                    <th className="f12-500" style={{ width: "10%" }}>
                      Amount
                    </th>
                    <th className="f12-500" style={{ width: "10%" }}>
                      ETC
                    </th>
                    <th className="f12-500" style={{ width: "8%" }}>
                      Counter <br />
                      No.
                    </th>
                    <th className="f12-500" style={{ width: "8%" }}>
                      Substitute <br />
                      Cancel
                    </th>
                    <th style={{ width: "10%" }}>Item Status</th>
                  </tr>
                </thead>
                {this.props?.allData?.order_items.map((item, index) => (
                  <tbody key={index}>
                    <tr>
                      <td style={{ width: "5%" }}>
                        {ITEMTYPEVEG.map((type, index) => {
                          return (
                            <React.Fragment key={index}>
                              {item?.item?.itemType === type?.value ? (
                                <Image
                                  width="20px"
                                  src={type.url}
                                  alt={type.title}
                                  title={type.title}
                                  fluid
                                />
                              ) : null}
                            </React.Fragment>
                          );
                        })}
                      </td>
                      <td style={{ width: "10%" }}>{item.item.name}</td>
                      <td style={{ width: "3%" }}>{item.quantity}</td>
                      <td style={{ width: "10%" }}>
                        {" "}
                        {item && item.addOns.length > 0 ? (
                          this.getAddOns(item && item.addOns)
                        ) : (
                          <Fragment>N/A</Fragment>
                        )}
                      </td>
                      <td style={{ width: "20%" }}>
                        {item && item.customised_details
                          ? this.prepareLevels(item && item.customised_details)
                          : " "}{" "}
                        {item && item.notes}
                      </td>
                      <td style={{ width: "10%" }}>
                        ₹ {item && item.size && item.size.price}
                      </td>
                      <td style={{ width: "10%" }}>
                        {" "}
                        {item && item.item && item.item.prepTime} Min
                      </td>
                      <td style={{ width: "8%" }}>
                        {" "}
                        {item && item.item && item.item.counter_number}
                      </td>
                      <td style={{ width: "8%" }}>
                        <div class="col-12">
                          <img
                            src={require("../../../../../assets/images/superadmin/ordericon/uncheck.svg")}
                            width="25px"
                            alt="Substitute"
                            className="mb-2"
                          />
                        </div>
                      </td>
                      <td style={{ width: "14%" }}>
                        <div className="btn btn-outline-success">
                          {this.props?.allData &&
                          this.props?.allData?.order_status === 0 ? (
                            "Pending"
                          ) : this.props?.allData?.order_status === 1 ? (
                            "Confirmed"
                          ) : this.props?.allData?.order_status === 2 ? (
                            "Getting Prep"
                          ) : this.props?.allData?.order_status === 3 &&
                            this.props?.allData &&
                            this.props?.allData?.order_type === 3 ? (
                            "Food Plating"
                          ) : this.props?.allData?.order_status === 3 ? (
                            "Packing"
                          ) : this.props?.allData?.order_status === 4 &&
                            this.props?.allData &&
                            this.props?.allData?.order_type === 3 ? (
                            <>
                              Ready for
                              <br /> Dine-in
                            </>
                          ) : this.props?.allData?.order_status === 4 &&
                            this.props?.allData &&
                            this.props?.allData?.order_type === 0 ? (
                            <>
                              Ready for
                              <br /> Take Away
                            </>
                          ) : this.props?.allData?.order_status === 4 ? (
                            <>
                              Ready To
                              <br /> Pick
                            </>
                          ) : this.props?.allData?.order_status === 5 &&
                            this.props?.allData &&
                            this.props?.allData?.order_type === 7 ? (
                            <>
                              Out for
                              <br /> Delivery
                            </>
                          ) : this.props?.allData?.order_status === 5 ? (
                            "On The Way"
                          ) : this.props?.allData?.order_status === 6 &&
                            this.props?.allData &&
                            this.props?.allData?.order_type === 3 ? (
                            "Served"
                          ) : this.props?.allData?.order_status === 6 ? (
                            "Delivered"
                          ) : this.props?.allData?.order_status === 7 ? (
                            "Complete"
                          ) : this.props?.allData?.order_status === 8 ? (
                            "Cancelled"
                          ) : null}
                        </div>
                        <div className="f10-400 mt-2">Current Status</div>
                      </td>
                      {/* <td style={{ width: "10%" }}>
                      
                        {item.isCancelled ||
                        this.props?.allData?.order_status === 8 ? (
                          "Cancelled"
                        ) : this.props?.allData?.order_status === 7 ? (
                          "Completed"
                        ) : (
                          <Fragment>
                            <div align="center">
                              <img
                                src={require("../../../../../assets/images/superadmin/ordericon/uncheck.svg")}
                                width="25px"
                              />
                              <br />
                              <button
                                className="btn btn-danger"
                                onClick={() =>
                                  this.onClickShowSubstituteModal(
                                    item,
                                    this.props?.allData?._id,
                                    index
                                  )
                                }
                              >
                                Substitute/
                                <br />
                                Cancel
                              </button>
                            </div>
                          </Fragment>
                        )}
                      </td> */}
                    </tr>
                  </tbody>
                ))}
                {/* <span style={{ color: "red" }}>Substituted Item</span> */}
                {this.props?.allData &&
                  this.props?.allData?.order_items.map((item, index) => (
                    <Fragment key={index}>
                      {item.isSubstituted ? (
                        <tbody>
                          <tr>
                            <td style={{ width: "3%" }}>
                              {ITEMTYPEVEG.map((type, index) => {
                                return (
                                  <React.Fragment key={index}>
                                    {item?.item?.itemType === type?.value ? (
                                      <Image
                                        width="20px"
                                        src={type.url}
                                        alt={type.title}
                                        title={type.title}
                                        fluid
                                      />
                                    ) : null}
                                  </React.Fragment>
                                );
                              })}
                            </td>

                            <td style={{ width: "10%" }}>
                              {item.item.name} <br />
                            </td>
                            <td style={{ width: "3%" }}>{item.quantity}</td>
                            <td style={{ width: "10%" }}>
                              {item && item.addOns.length > 0 ? (
                                this.getAddOns(item && item.addOns)
                              ) : (
                                <Fragment>N/A</Fragment>
                              )}
                            </td>
                            <td className="text-break" style={{ width: "20%" }}>
                              {item && item.customised_details
                                ? this.prepareLevels(
                                    item && item.customised_details
                                  )
                                : " "}{" "}
                              {item && item.notes}
                            </td>
                            <td style={{ width: "10%" }}>
                              ₹ {item && item.size && item.size.price}
                            </td>
                            <td style={{ width: "10%" }}>
                              {item && item.item && item.item.prepTime} Min
                            </td>
                            <td style={{ width: "10%" }}>
                              {item && item.item && item.item.counter_number}
                            </td>
                            <td style={{ width: "14%" }}>
                              <div align="center">
                                <img
                                  src={require("../../../../../assets/images/superadmin/ordericon/check.svg")}
                                  width="25px"
                                />
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        <> </>
                      )}
                    </Fragment>
                  ))}
              </table>
            </div>
          </div>
          <br />
          <br />
          <h4 className="f16-500">Details</h4>
          <br />
          <div className="details-model-orders-view">
            <Row>
              <Col className="col-6 col-sm-6 col-md-3">
                <h4 className="f12-500">Request Number</h4>
                <br />
                <p className="f12-400">#{this.props?.allData?.order_id}</p>
                <br />
              </Col>
              <Col className="col-6 col-sm-6 col-md-3">
                <h4 className="f12-500">User Status</h4>
                <br />
                <p className="f12-400">
                  {this.props?.allData?.userConfirmed
                    ? "Confirmed by User"
                    : "Not Confirmed by User"}
                </p>
                <br />
              </Col>
              <Col className="col-6 col-sm-6 col-md-3">
                <h4 className="f12-500">Requested Date / Time</h4>
                <br />
                <p className="f12-400">
                  {this.props?.allData?.now
                    ? moment(this.props?.allData?.createdAt).format(
                        "Do MMMM YYYY hh:mm a"
                      )
                    : moment(this.props?.allData?.later_date).format(
                        "Do MMMM YYYY hh:mm a"
                      )}
                </p>
                <br />
              </Col>
              <Col className="col-6 col-sm-6 col-md-3">
                <h4 className="f12-500">Created Date / Time</h4>
                <br />
                <p className="f12-400">
                  {moment(this.props?.allData?.createdAt).format(
                    "Do MMMM YYYY hh:mm a"
                  )}
                </p>
                <br />
              </Col>
            </Row>
            <br />
            <hr />
            <br />
            <Row>
              <Col className="col-6 col-sm-6 col-md-3">
                <h4 className="f12-500">Changed Date / Time</h4>
                <br />
                <p className="f12-400">
                  {moment(this.props?.allData?.updatedAt).format(
                    "Do MMMM YYYY hh:mm a"
                  )}
                </p>
                <br />
              </Col>
              <Col className="col-6 col-sm-6 col-md-3">
                <h4 className="f12-500">Point Of Entry</h4>
                <br />
                <p className="f12-400">-</p>
                <br />
              </Col>
              <Col className="col-6">
                <h4 className="f12-500">Reason for Cancel/ Reject</h4>
                <br />
                <p className="f12-400">-</p>
                <br />
              </Col>
            </Row>
          </div>
          <br />
          <br />
          <h4 className="f16-500">Transaction Details</h4>
          <br />
          <div className="details-model-orders-view table-responsive">
            <table className="table table-borderless">
              <thead style={{ marginBottom: "1%" }}>
                <tr>
                  <th className="f12-500" style={{ width: "20%" }}>
                    Transaction ID
                  </th>
                  <th className="f12-500" style={{ width: "20%" }}>
                    Amount
                  </th>
                  <th className="f12-500" style={{ width: "20%" }}>
                    Payment Method
                  </th>
                  <th className="f12-500" style={{ width: "20%" }}>
                    Payment Status
                  </th>
                  <th className="f12-500" style={{ width: "20%" }}>
                    Date & Time
                  </th>
                </tr>
              </thead>
              <tbody>
                {this.props?.allData?.transactionDetails.map((item, index) => (
                  <tr key={index}>
                    <td className="f12-400" style={{ width: "20%" }}>
                      {item?.txnId || item?._id}
                      {console.log("item ===>", item)}
                    </td>
                    <td
                      className="f14-500"
                      style={{
                        width: "20%",

                        color:
                          item?.type === "REFUND" && item?.paid
                            ? "#EE3A23"
                            : item?.type !== "REFUND" && item?.paid
                            ? "#1AB61E"
                            : "#EE3A23",
                        // item?.paid ? "#1AB61E" : "#EE3A23",
                      }}
                    >
                      <i class="fa fa-rupee"></i> {item?.amount.toFixed(2)}
                    </td>
                    <td className="f12-400" style={{ width: "20%" }}>
                      {item && item?.paymentType === 0
                        ? "COD"
                        : item?.paymentType === 1
                        ? "UPI"
                        : item?.paymentType === 2
                        ? "Paytm"
                        : item?.paymentType === 3
                        ? "Debit Card"
                        : item?.paymentType === 4
                        ? "Credit Card"
                        : item?.paymentType === 5
                        ? "NetBanking"
                        : item?.paymentType === 6
                        ? "Pay Later"
                        : item?.paymentType === 7
                        ? "Wallet"
                        : item?.paymentType === 8
                        ? "External Wallet"
                        : item?.paymentType === 9
                        ? "Cash"
                        : "-"}
                    </td>
                    <td className="f12-400" style={{ width: "20%" }}>
                      {item?.type === "REFUND" && item?.paid
                        ? "Refund"
                        : item?.type !== "REFUND" && item?.paid
                        ? "Paid"
                        : "Unpaid"}
                      {/* {item?.paid ? "Paid1" : "Unpaid"} */}
                    </td>
                    <td className="f12-400" style={{ width: "20%" }}>
                      {moment(item?.date).format("Do MMMM YYYY, hh:mm a")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <br />
          <h4 className="f16-500">View Audit Log</h4>
          <br />
          <div className="details-model-orders-view table-responsive">
            <table className="table table-borderless">
              <thead style={{ marginBottom: "1%" }}>
                <tr>
                  <th className="f12-500" style={{ width: "15%" }}>
                    Date
                  </th>
                  <th className="f12-500" style={{ width: "70%" }}>
                    Operation
                  </th>
                  <th style={{ width: "15%" }}></th>
                </tr>
              </thead>
              {this.props?.allData?.auditLogs.map((item, index) => (
                <tbody key={index}>
                  <tr>
                    <td className="f11-500" style={{ width: "15%" }}>
                      {moment(item.timestamp).format("MMMM Do YYYY")} <br />{" "}
                      {moment(item.timestamp).format("LT")}
                    </td>
                    <td className="f11-500" style={{ width: "70%" }}>
                      {item.message}
                    </td>
                    <td
                      className="f11-500"
                      style={{ width: "15%", textAlign: "right" }}
                    >
                      {item.initiator}
                    </td>
                  </tr>
                </tbody>
              ))}
            </table>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default OrderDescModelBody;
